import React, {useRef, useState} from 'react';
import './styles/navbar.css'
import logo from '../assents-img/logo.svg'
import {Link, NavLink} from 'react-router-dom'
import Media from 'react-media'
import {  TweenMax, Power3 } from 'gsap';
import ChangeLenguage from './Change-lenguage';
import { useTranslation } from 'react-i18next';
import Whats from './whatsapp';

export default function Navbar() {
    const { t } = useTranslation();
    const [state, setstate] = useState(false)


    const openMenu = ()=> {
        
        if (state) {
            setstate(false)
        } else {
            setstate(true)
        }
    }
        
        return (
            <React.Fragment>
                  <Whats></Whats>
                <Media query={{maxWidth:838}}>
                
                <div className='nav'> {/*Mobile Menu*/}
                    <div className='menu-wrapper'>
                    <div onClick={openMenu} className='buttonOpen'>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                    </div>
                    <Link to="/">
                    <img className='logo' src={logo} alt=""/>
                    </Link>

                    </div>
                    <div className={state ? 'menu-mobile openMenu' : 'menu-mobile'}>
                    <div onClick={openMenu} className='buttonClose'>
                            <span className='first' ></span>
                            <span className='second'></span>
                    </div>
                    <ul id='menu' className='menu-list'> 
                        <h3>Menu</h3>
                        <hr/>
                        <Link to='/'>{t('navHome')}</Link> <br/>
                        <Link to='/Nosotros' >{t('titleAbout')}</Link> <br/>
                        <Link to='/tratamientos'>{t('titleTreatments')}</Link> <br/>
                        <Link to='/Instalaciones'>{t('titleFacilities')}</Link> <br/>
                        <Link to='/Contacto' >{t('titleContact')}</Link><br/>
                        <ChangeLenguage></ChangeLenguage>
                    </ul>
                    <div className="footer-menu">
                    <img className='logo' src={logo} alt=""/>
                        <div className="contact-info-footer">
                        <h3>{t('navMobile')}</h3>
                        <hr/>
                        <br/>
                        <h3>2582-0782 / 8736-8734</h3>

                        </div>
                     </div>
                     </div>
                    </div>
                </Media> 
                <Media query={{minWidth:839}}>

                <nav className='nav'> {/*Desktop Menu*/}
                    <div className="menu">
                    <ul> 
                    <img className='logo' src={logo} alt=""/>
                        <ChangeLenguage></ChangeLenguage>
                        <NavLink activeClassName='active' to="/Contacto"> {t('titleContact')}</NavLink> 
                        <NavLink activeClassName='active' to="/Instalaciones"> {t('titleFacilities')}</NavLink> 
                        <NavLink activeClassName='active' to='/tratamientos'>  {t('titleTreatments')} </NavLink>
                        <NavLink activeClassName='active' to="/Nosotros"> {t('titleAbout')}</NavLink>
                        <NavLink activeClassName='active'to='/'> {t('navHome')} </NavLink>
                    </ul>
                    </div>
                </nav>
                
                </Media>
                
            </React.Fragment>
        );
    }

